import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { SubscribeComponent } from './footer/subscribe/subscribe.component';
import { FooterComponent } from './footer/footer.component';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { AboutusComponent } from './aboutus/aboutus.component';
import { FAQComponent } from './faq/faq.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermAndConditionComponent } from './term-and-condition/term-and-condition.component';
import { CancellationPolicyComponent } from './cancellation-policy/cancellation-policy.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { PricingComponent } from './pricing/pricing.component';
import { ModalModule } from 'ngx-bootstrap';
import { AccountModule } from './account/account.module';
import { CommonModule } from '@angular/common';
import { MyBookingsComponent } from './my-bookings/my-bookings.component';
import { ResetPassowordComponent } from './common/resetPassoword.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BlogsComponent } from './blogs/blogs.component';
import { BlogsModule } from './blogs/blogs.module';
/*import { MapComponent } from './map/map.component';*/
import { ChartComponent } from './chart/chart.component';
import { NgxEchartsModule } from 'ngx-echarts';


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    SubscribeComponent,
    AboutusComponent,
    //MapComponent,
    ChartComponent,
    FAQComponent,
    PrivacyPolicyComponent,
    TermAndConditionComponent,
    CancellationPolicyComponent,
    ContactUsComponent,
    ResetPassowordComponent,
    PricingComponent,
    MyBookingsComponent,
    BlogsComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    TypeaheadModule.forRoot(),
    BrowserAnimationsModule,
    BsDatepickerModule.forRoot(),
    ModalModule.forRoot(),
    AccountModule,
    RouterModule,
    FormsModule,
    BlogsModule,
    ReactiveFormsModule,
    NgxEchartsModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [DatePipe],
  exports: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
